import axiosServices from '../utils/axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const fetchInterviews = async (paginationModel) => {
  const response = await axiosServices.get(`${backendUrl}/qualitative-studies/`, {
    params: paginationModel,
  });
  return response.data;
};
export const fetchInterview = async (id) => {
  const response = await axiosServices.get(`${backendUrl}/qualitative-studies/${id}/`);
  return response.data;
};
export const updateInterviewFinalize = async ({ id, transformedData, processId }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${id}/?process_id=${processId}`,
    transformedData,
  );
  return response.data;
};
export const updateInterviewStatus = async ({ id, transformedData }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${id}/`,
    transformedData,
  );
  return response.data;
};
export const fetchInterviewDetails = async (id) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${id}/finalizable_details/`,
  );
  return response.data;
};
export const fetchCodeBook = async (id) => {
  const response = await axiosServices.get(`${backendUrl}/qualitative-studies/${id}/codebook/`);
  return response.data;
};
export const fetchTranscripts = async (id) => {
  const response = await axiosServices.get(`${backendUrl}/qualitative-studies/${id}/transcripts/`);
  return response.data;
};
export const fetchTranscript = async (id) => {
  const response = await axiosServices.get(`${backendUrl}/qualitative-studies/${id}/transcripts/`);
  return response.data;
};
export const fetchAnalysis = async (id) => {
  const response = await axiosServices.get(`${backendUrl}/qualitative-studies/${id}/themes/`);
  return response.data;
};
export const createInterview = async (formData) => {
  // Validate input data
  if (!formData || typeof formData !== 'object') {
    throw new Error('Invalid form data provided');
  }

  if (!formData.title?.trim()) {
    throw new Error('Interview title is required');
  }

  const payload = {
    ...formData,
  };

  const response = await axiosServices.post(`${backendUrl}/qualitative-studies/`, payload);

  return response.data;
};
export const updateInterview = async ({ id, payload }) => {
  const response = await axiosServices.patch(`${backendUrl}/qualitative-studies/${id}/`, payload);
  return response.data;
};
export const stopCollectingResponsesInterview = async ({ interview_id, disable_reason }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/${interview_id}/disable-study/?disable_reason=${disable_reason}`,
  );
  return response.data;
};
export const deleteInterviews = async (id) => {
  const response = await axiosServices.delete(`${backendUrl}/qualitative-studies/${id}/`);
  return response.data;
};
export const duplicateInterview = async (id) => {
  const response = await axiosServices.post(`${backendUrl}/qualitative-studies/?study_id=${id}`);
  return response.data;
};
export const createLinkBasedShareInterview = async ({ interviewId, returnUrl }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/link-based-share-request/${interviewId}/?return_url=${returnUrl}`,
  );
  return response.data;
};
export const revokeLinkBasedShareInterview = async ({ interviewId, token }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/link-based-share-request/${interviewId}/revoke/?token=${token}`,
  );
  return response.data;
};
export const analyzeInterview = async (
  studyId,
  analysis_lens_type,
  transcript_ids,
  analysis_level = '',
  analysis_item_id = null,
  workspaceId = null,
) => {
  // workspace_id required for atomic credit deduction (unless regeneration with analysis_item_id)
  const url = `${backendUrl}/qualitative-studies/${studyId}/analyses/lenses/run${workspaceId ? `?workspace_id=${workspaceId}` : ''}`;
  const payload = {
    analysis_lens_type,
    transcript_ids,
    analysis_level,
  };
  // Include analysis_item_id if provided (for regenerating themes/report)
  if (analysis_item_id) {
    payload.analysis_item_id = analysis_item_id;
  }
  const { data } = await axiosServices.post(url, payload);
  return data;
};
export const generateInterviewCodes = async (id) => {
  const response = await axiosServices.post(`${backendUrl}/qualitative-studies/${id}/codes/`);
  return response.data;
};
export const generateInterviewCodeBook = async (id) => {
  const response = await axiosServices.post(`${backendUrl}/qualitative-studies/${id}/codebook/`);
  return response.data;
};
export const generateInterviewReport = async (id) => {
  const response = await axiosServices.post(`${backendUrl}/qualitative-studies/${id}/report/`);
  return response.data;
};
export const getInterviewReport = async ({ interviewId }) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${interviewId}/report/`,
  );
  return response.data;
};
export const generateInterviewThemes = async (id) => {
  const response = await axiosServices.post(`${backendUrl}/qualitative-studies/${id}/themes/`);
  return response.data;
};
export const generateInterviewId = async (formData) => {
  const response = await axiosServices.post(`${backendUrl}/qualitative-studies/`, formData);
  return response.data;
};
export const generateUploadUrl = async (formData) => {
  const response = await axiosServices.post(`${backendUrl}/upload/generate-upload-url`, formData);
  return response.data;
};
export const generateMultiUploadUrl = async (formData) => {
  const { study_id, ...rest } = formData;

  // If there's form data (from interview upload flow), use the base endpoint
  // Otherwise (from transcripts), use the endpoint with study_id
  const endpoint = rest.title
    ? `${backendUrl}/qualitative-studies/upload/generate-upload-url`
    : `${backendUrl}/qualitative-studies/upload/generate-upload-url?study_id=${study_id}`;

  const response = await axiosServices.post(endpoint, {
    ...rest,
  });
  return response.data;
};
export const commitBlocks = async (formData) => {
  const response = await axiosServices.post(`${backendUrl}/upload/commit-blocks`, formData);
  return response.data;
};
export const commitMultiBlocks = async (formData) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/upload/commit-blocks`,
    formData,
  );
  return response.data;
};
export const saveAndAnalyzeInterviewAudioVideo = async ({ id, processId, ...payload }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/save_and_transcript_generate/${id}/?process_id=${processId || ''}`,
    payload,
  );
  return response.data;
};
export const fetchTranscriptList = async ({ studyId, filterList, pagination, statusFilter }) => {
  const { limit = 15, offset = 0 } = pagination || {};
  const statusParam = statusFilter ? `&status_filter=${encodeURIComponent(statusFilter)}` : '';
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${studyId}/transcripts/?limit=${limit}&offset=${offset}&filter_list=${JSON.stringify(
      filterList,
    )}${statusParam}`,
  );
  return response.data;
};
export const fetchTranscriptDetails = async ({ studyId, transcriptId }) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${studyId}/transcripts/${transcriptId}/`,
  );
  return response.data;
};
export const fetchTranscriptSummary = async ({ transcriptId }) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/transcripts/${transcriptId}/summary`,
  );
  return response.data;
};
export const fetchInterviewCodebook = async ({ studyId }) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${studyId}/codebook/`,
  );
  return response.data;
};
export const fetchInterviewAnalysis = async ({ studyId }) => {
  const response = await axiosServices.get(`${backendUrl}/qualitative-studies/${studyId}/themes/`);
  return response.data;
};
export const fetchCodeQuotes = async ({ studyId }) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${studyId}/codes_quotes/`,
  );
  return response.data;
};
export const deleteTranscript = async (id) => {
  const response = await axiosServices.delete(
    `${backendUrl}/qualitative-studies/transcript/${id}/`,
  );
  return response.data;
};
export const deleteCategory = async (payload) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${payload?.id}/categories/delete`,
    payload,
  );
  return response.data;
};
export const removeInterviewCode = async (payload) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${payload?.qualitative_item_id}/codes/remove`,
    payload,
  );
  return response.data;
};
export const removeCodeFromCategory = async (payload) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${payload?.study_id}/categories/codes/remove`,
    payload,
  );
  return response.data;
};
export const addCodeFromCategory = async (payload) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${payload?.study_id}/categories/codes/add`,
    payload,
  );
  return response.data;
};
export const deleteInterviewCode = async (payload) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${payload?.qualitative_item_id}/codes/delete`,
    payload,
  );
  return response.data;
};
export const addStudyTag = async ({ payload, studyId }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/studies/${studyId}/tags/`,
    payload,
  );
  return response.data;
};
export const addStudyTagOption = async ({ payload, studyId, tagId }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/studies/${studyId}/edit-tags-add-value/${tagId}/`,
    payload,
  );
  return response.data;
};
export const updateStudyTagOption = async ({ payload, studyId, tagId, valueId }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/studies/${studyId}/tag/${tagId}/?value_id=${valueId}`,
    payload,
  );
  return response.data;
};
export const assignUnassignTagInTranscript = async ({
  payload,
  studyId,
  transcriptId,
  speakerId,
}) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/studies/${studyId}/assign-unassign/transcript/${transcriptId}/tags/?assign=${payload.isAssignTag}${speakerId ? `&speaker_id=${speakerId}` : ''}`,
    payload,
  );
  return response.data;
};
export const assignTagInTranscript = async ({ payload, studyId, transcriptId, speakerId }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/studies/${studyId}/assign/transcript/${transcriptId}/tags/${speakerId ? `?speaker_id=${speakerId}` : ''}`,
    payload,
  );
  return response.data;
};
export const updateStudyTagAttribute = async ({ payload, studyId, tagId }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/studies/${studyId}/tag/${tagId}/`,
    payload,
  );
  return response.data;
};
export const addTag = async ({ payload, transcriptId }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/transcript/${transcriptId}/tags/`,
    payload,
  );
  return response.data;
};
export const fetchStudyTags = async ({ studyId, searchQuery }) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/studies/${studyId}/tags/fetch/?query=${searchQuery}`,
  );
  return response.data;
};
export const fetchAssignedTag = async (studyId, searchQuery) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/studies/${studyId}/assign_tags/?q=${searchQuery}`,
  );
  return response.data;
};
export const copyTagsFromStudy = async ({ targetStudyId, sourceStudyId }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/studies/${targetStudyId}/tags/copy-from/${sourceStudyId}`,
  );
  return response.data;
};
export const fetchLensSummaries = async ({ transcriptId }) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/transcripts/${transcriptId}/lens_summaries`,
  );
  return response.data;
};
export const deleteStudyTag = async ({ id, tagId, valueId }) => {
  const response = await axiosServices.delete(
    `${backendUrl}/qualitative-studies/studies/${id}/tag/${tagId}${valueId ? `/?value_id=${valueId}` : '/'}`,
  );

  return response.data;
};
export const updateTranscriptName = async ({ payload, transcriptId, id }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${id}/transcript/${transcriptId}/`,
    payload,
  );
  return response.data;
};
export const addSpeakerTag = async ({ payload, transcriptId, speakerId }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/transcript/${transcriptId}/tags/?speaker_id=${speakerId}`,
    payload,
  );
  return response.data;
};
export const udpateCodeDetails = async ({ payload, transcriptId }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${transcriptId}/codes/edit`,
    payload,
  );
  return response.data;
};
export const udpateCategoryDetails = async ({ payload }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${payload.study_id}/categories/update`,
    payload,
  );
  return response.data;
};
export const udpateThemeDetails = async ({ payload }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${payload.study_id}/themes/update`,
    payload,
  );
  return response.data;
};
export const updateSpeaker = async ({ payload, transcriptId }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${transcriptId}/change-speaker/`,
    payload,
  );
  return response.data;
};
export const updateSpeakerInfo = async ({ payload, transcriptId, speakerId }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${transcriptId}/speaker/${speakerId}/`,
    payload,
  );
  return response.data;
};
export const addNewParticipant = async ({ payload, transcriptId }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/${transcriptId}/create-participant/`,
    payload,
  );
  return response.data;
};
export const deleteSpeakerTag = async (payload) => {
  const response = await axiosServices.delete(
    `${backendUrl}/qualitative-studies/transcript/${payload?.transcriptId}/tag/${payload?.attribute}/?speaker_id=${payload.speakerId}`,
  );
  return response.data;
};
export const addNewCode = async ({ payload, transcriptId }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${transcriptId}/codes/create`,
    payload,
  );
  return response.data;
};
export const assignCode = async ({ payload, transcriptId }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/qualitative-studies/${transcriptId}/codes/assign_codes`,
    payload,
  );
  return response.data;
};
export const generateWelcomeMessage = async (payload) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/predict_welcome_message`,
    payload,
  );
  return response.data;
};
export const editTranscriptText = async (payload) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/${payload?.qualitative_item_id}/update_text`,
    payload,
  );
  return response.data;
};
export const getTranscriptRecording = async (itemId) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/merge_recordings/${itemId}/`,
  );
  return response.data;
};
export const getChatHistory = async (studyId) => {
  const response = await axiosServices.get(`${backendUrl}/chats?study_id=${studyId}`);
  return response.data;
};
export const getChatHistoryById = async (chatId) => {
  const response = await axiosServices.get(`${backendUrl}/chat/${chatId}`);
  return response.data;
};
export const likeDislikeChat = async (payload) => {
  const response = await axiosServices.patch(
    `${backendUrl}/chat/${payload.chatId}/turn/${payload.turnId}/feedback`,
    payload.feedback,
  );
  return response.data;
};
export const fetchLatestChatId = async (studyId) => {
  try {
    const response = await axiosServices.get(`${backendUrl}/latest-chat-id?study_id=${studyId}`);
    return response.data;
  } catch (error) {
    const status = error?.response?.status;
    if (status === 404) {
      return null;
    }
    throw error;
  }
};
export const fetchCodeDetails = async ({ studyId, codeName }) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/analysis/${studyId}/code_info?code_name=${codeName}`,
  );
  return response.data;
};

export const markAsCompleted = async ({ studyId, transcriptId, isCompleted }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/change-completed-status`,
    {
      study_id: studyId,
      qualitative_item_id: transcriptId,
      is_completed: isCompleted,
    },
  );
  return response.data;
};

export const exportInterviewParticipantData = async (studyId) => {
  const response = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${studyId}/participant/export`,
  );
  return response.data;
};

export const searchTranscripts = async ({
  studyId,
  search_term,
  searchType,
  threshold,
  offset = 0,
  limit = 10,
}) => {
  const response = await axiosServices.post(`${backendUrl}/qualitative-studies/${studyId}/search`, {
    search_term,
    search_type: searchType,
    threshold,
    offset,
    limit,
  });
  return response.data;
};

export const predictResearchQuestions = async (payload) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/predict_research_questions`,
    payload,
  );
  return response.data;
};

export const predictInterviewGuidelines = async (payload) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/predict_interview_guidelines`,
    payload,
  );
  return response.data;
};

export const exportInterviewTranscripts = async (studyId) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/${studyId}/transcripts/export`,
  );
  return response.data;
};

export const queueSemanticEmbedding = async ({ studyId, transcriptIds = [] }) => {
  const response = await axiosServices.post(
    `${backendUrl}/qualitative-studies/studies/${studyId}/semantic-embeddings/queue`,
    {
      transcript_ids: transcriptIds,
    },
  );
  return response.data;
};

export const closeInterview = async (studyId) => {
  const response = await axiosServices.post(`${backendUrl}/qualitative-studies/${studyId}/close/`);
  return response.data;
};
